import { contentfulProductResDto } from '@web/common';
import { publicAPI } from '../PublicAPI';

export const getLandingPageProducts = async () => {
  return publicAPI.get(`/api/products`, contentfulProductResDto);
};
